import React from 'react';
import { Popconfirm, Icon } from 'antd';
import IconGhostBtn from './IconGhostBtn'

class IconConfirmBtn extends React.Component {
    handleConfirm = (e) => {
        if (this.props.onConfirmClick) this.props.onConfirmClick(e);
    };

    render() {
        const {
            mainColor = 'black',
            btnIcon: IconComponent,
            btnTitle,
            btnSize,
            btnIconColor = mainColor,
            confirmTitle = '¿Desea confirmar la acción?',
            confirmIconType = 'question-circle',
            confirmIconColor = mainColor,
            confirmOkText = 'Confirmar',
            confirmOkColor = mainColor,
            confirmOkColorText = 'white',
            confirmCancelText = 'Cancelar',
            confirmCancelColor = 'white',
            confirmCancelColorText = 'black'
        } = this.props;
  
        return (
            <div onClick={(e) => {e.stopPropagation()}}>
                <Popconfirm 
                    title       = { confirmTitle }
                    icon        = { <Icon type={confirmIconType} style={{ color:confirmIconColor }} /> }
                    onConfirm   = { this.handleConfirm }
                    onCancel    = { (e) => {e.stopPropagation()} }
                    okText      = { confirmOkText }
                    cancelText  = { confirmCancelText }
                    okButtonProps={{ style: { backgroundColor: confirmOkColor, borderColor: confirmOkColorText, color: confirmOkColorText } }}
                    cancelButtonProps={{ style: { backgroundColor: confirmCancelColor, borderColor: confirmCancelColorText, color: confirmCancelColorText } }}
                >
                    <IconGhostBtn
                        icon={IconComponent}
                        btnIconColor={btnIconColor}
                        btnSize={btnSize}
                        btnTitle={btnTitle}
                        onClick={(e) => {e.stopPropagation()}}
                    />
                </Popconfirm>
            </div>
        );
    }
}
export default IconConfirmBtn;